








import CommonBase from "../CommonBase";
import {Component, Inject, Prop} from "vue-property-decorator";
import Api from "./Api";
import {PhoneNumber} from "../../modules/models";
import {requireNum} from "../../modules/utils";
import {componentLoad} from "../../modules/loading";
import rd from "@/modules/vRoutedefs";
import {ignoreRedundantNavErr} from "@/router";

// Starts qr code reader, and waits for card to be read.
// When card is read, qr code is sent to server that resolves it to a "pending card".
// "signupverified" is then loaded, which displays the pending card for next step processing.
@Component({
    components: {
        "at-qr-reader": componentLoad(() => import(/* webpackChunkName: "QrReader" */ "../qr/QrReader.vue")),
    }
})
export default class SignupQr extends CommonBase {
    @Inject()
    api!: Api;
    @Prop()
    phone!: PhoneNumber;
    @Prop({default: ""})
    redir!: string;

    get cancelTo() {
        return {name: rd.login.signup.name, params: {countrycode: ""+this.phone.countrycode, number: ""+this.phone.number}, query: {redir: this.redir}};
    }

    onCardPending(cardNumStr: string) {
        const cardNum = requireNum(cardNumStr);
        ignoreRedundantNavErr(this.$router.push({name: rd.login.signup.verified.name, params: {countrycode: this.phone.countrycode.toString(), number: this.phone.number.toString(), cardnum: cardNum.toString()}, query: {redir: this.redir}}));
    }
}
